import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, Table } from "@mantine/core";
import React from "react";
import { AutoHeightContainer } from "./Internal";
export const ManagedTable = ({ header, rows, footer, caption, fetching, emptyState, tableStyles, withBorder = false, minWidth = "max-content" }) => {
    //
    const headerColumnCount = React.Children.count(header?.props.children ?? []) ||
        header?.props?.columns?.filter((c) => !c.hidden)
            .length ||
        0;
    const isEmpty = !fetching && !rows?.length;
    return (_jsxs(AutoHeightContainer, { style: {
            height: "100%",
            marginBottom: "0.5rem",
            padding: withBorder ? "0.5rem" : "none",
            border: withBorder
                ? "1px solid var(--mantine-color-gray-3)"
                : "none",
            borderRadius: withBorder ? "0.65rem" : "none"
        }, children: [_jsx("div", { style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: "auto"
                }, children: _jsxs(Table, { style: {
                        minWidth,
                        ...(isEmpty && { height: "100%" }),
                        ...tableStyles
                    }, children: [_jsx(Table.Thead, { children: header }), fetching && (_jsx(Table.Tbody, { id: "scrollableContainer", children: Array.from({ length: 25 }).map((_, index) => (_jsx(Table.Tr, { children: Array.from({
                                    length: headerColumnCount
                                }).map((_, colIndex) => (_jsx(Table.Td, { children: _jsx(Skeleton, { height: 35 }) }, colIndex))) }, index))) })), rows && rows.length > 0 && !fetching && (_jsx(Table.Tbody, { id: "scrollableContainer", children: rows })), isEmpty && (_jsx(Table.Tbody, { id: "scrollableContainer", style: { height: "100%" }, children: _jsx(Table.Tr, { style: { height: "100%" }, children: _jsx(Table.Td, { colSpan: headerColumnCount || undefined, style: { height: "100%", padding: 0 }, children: emptyState ?? _jsx("div", {}) }) }) }))] }) }), _jsxs(Table, { children: [footer && _jsx(Table.Tfoot, { children: footer }), caption && _jsx(Table.Caption, { children: caption })] })] }));
};
